import { render, staticRenderFns } from "./LookupModal.vue?vue&type=template&id=67de21ea"
import script from "./LookupModal.vue?vue&type=script&lang=ts"
export * from "./LookupModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports